module.exports = __webpack_public_path__ + "img/prohibited.d8773167.gif";